/** Format an ISO date string (YYYY-MM-DD) as DD-MMM-YYYY (the product's display standard).
 * Returns "—" for null/empty/invalid inputs so callers can drop it into a table cell. */
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatDateDDMMMYYYY(input) {
  if (!input) return "—";
  // Accept a Date object or an ISO/parseable string.
  const d = input instanceof Date ? input : new Date(`${input}T00:00:00`);
  if (Number.isNaN(d.getTime())) return "—";
  const day = String(d.getDate()).padStart(2, "0");
  return `${day}-${MONTHS[d.getMonth()]}-${d.getFullYear()}`;
}

/** True when the ISO date is strictly in the past (today counts as active). */
export function isExpiredIso(iso) {
  if (!iso) return false;
  const d = new Date(`${iso}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
}
